import React, { useState } from 'react';
import SelectInput from './SelectInput';

const YearSelect = ({ initialYear, onYearChange }) =>
{
  const currentYear = new Date().getFullYear();
  const startYear = 2019;

  // Generate an array of years
  const years = [];
  for (let year = startYear; year <= currentYear; year++) {
    years.push(year);
  }

  // Set up the initial selected year in state
  const [selectedYear, setSelectedYear] = useState(initialYear || currentYear);

  // Handle selection change
  const handleChange = (event) => {
    const newYear = parseInt(event.target.value, 10);
    setSelectedYear(newYear);
    if (onYearChange) {
      onYearChange(newYear);
    }
  };

  return (
    <SelectInput default={selectedYear.toString()}
        label="Year"
        onChange = {handleChange}
        options = {years}
        ref={e => e}
        />
  );    
}

export default YearSelect;